import { sessionRouteBase } from "./sessionApiBase";

const ENTITY_TYPE_LABELS: Record<string, string> = {
  control_session: "Control Session",
  control: "Control",
  work_step_session: "Test",
};

const CHANGE_TYPE_LABELS: Record<string, string> = {
  state_transition: "Status Change",
  edit: "Edit",
};

const STATUS_LABELS: Record<string, string> = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  cancelled: "Cancelled",
  applied: "Applied",
  in_progress: "In Progress",
  in_review: "In Review",
  complete: "Complete",
};

const SNAPSHOT_FIELD_LABELS: Record<string, string> = {
  status: "Status",
  name: "Name",
  description: "Description",
  configuredState: "Configured State",
  configured_state: "Configured State",
  controlType: "Control Type",
  control_type: "Control Type",
  cycle: "Cycle",
  process: "Process",
  controlOwner: "Control Owner",
  control_owner: "Control Owner",
};

export function titleCase(str: string): string {
  return str.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatEntityType(value: string): string {
  return ENTITY_TYPE_LABELS[value] ?? titleCase(value);
}

export function formatChangeType(value: string): string {
  return CHANGE_TYPE_LABELS[value] ?? titleCase(value);
}

export function formatStatus(value: string): string {
  return STATUS_LABELS[value] ?? titleCase(value);
}

export function formatSnapshotFieldName(key: string): string {
  return SNAPSHOT_FIELD_LABELS[key] ?? titleCase(key);
}

export function getEntityLink(
  entityType: string,
  entityId: string,
): string | null {
  switch (entityType) {
    case "control_session":
      return `${sessionRouteBase("control")}/${entityId}`;
    case "control":
      return `/audit/controls/v2/${entityId}`;
    case "work_step_session":
      return `${sessionRouteBase("work_step")}/${entityId}`;
    default:
      return null;
  }
}

export function formatSnapshotValue(value: unknown): string {
  if (value === null || value === undefined) return "—";
  if (typeof value === "string") return STATUS_LABELS[value] ?? value;
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value === "number") return String(value);
  return JSON.stringify(value);
}
